import { useMemo } from "react";
import { useFirestore } from "hooks/firestore/core/useFirestore";
import { tokenAutomation } from "hooks/firestore/models/tokenAutomation";
import { tokenAllocation } from "hooks/firestore/models/tokenAllocation";
import useCanViewPromotions from "@/hooks/useCanViewPromotions";
import type { TokenContext } from "@/features/betslip/stores/types";

/**
 * Subscribe to the server data the betslip's composition-mutating
 * actions need, and shape it into the `TokenContext` they accept.
 *
 * SWR dedupes the underlying Firestore subscriptions, so calling this
 * from multiple wrapper hooks doesn't multiply reads.
 */
export const useTokenContext = (): TokenContext => {
  const { data: automations } = useFirestore(
    "/tokenAutomations",
    tokenAutomation.array(),
  );
  const { data: allocations } = useFirestore(
    "/users/{userId}/tokenAllocations",
    tokenAllocation.array(),
    { keyPath: "id" },
  );
  const canViewPromos = useCanViewPromotions();

  return useMemo<TokenContext>(
    () => ({
      allocations: allocations ?? [],
      automations: automations ?? [],
      canViewPromos,
    }),
    [allocations, automations, canViewPromos],
  );
};
